import * as React from "react";
import { InputGroup } from "@blueprintjs/core";
import debounce from "lodash.debounce";

interface Props {
  onChange: (term: string) => void;
  className?: string;
  leftIcon?: "search" | null | undefined;
  disabled?: boolean;
  defaultValue?: string | null;
  placeholder?: string;
}

interface State {
  term: string;
}

class AnnotationSearchInput extends React.Component<Props, State> {
  private readonly debouncedCallback: (term: string) => void;

  constructor(props: Props) {
    super(props);
    this.state = { term: "" };
    this.debouncedCallback = debounce(this.props.onChange, 400);
  }

  componentWillUnmount() {
    // eslint-disable-next-line
    (this.debouncedCallback as any).flush();
  }

  onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const term = e.currentTarget.value.trim();
    this.setState({ term });
    this.debouncedCallback(term);
  };

  onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  };

  render() {
    return (
      <form onSubmit={this.onSubmit} className={this.props.className}>
        <InputGroup
          type="search"
          onChange={this.onChange}
          placeholder={this.props.placeholder}
          leftIcon={this.props.leftIcon}
          disabled={this.props.disabled}
          defaultValue={this.props.defaultValue ? this.props.defaultValue : undefined}
        />
      </form>
    );
  }
}

export default AnnotationSearchInput;
